import React, { useState } from 'react';
import { Mail, X, Loader2, CheckCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EmailVerificationBanner = () => {
  const { user, isAuthenticated } = useAuth();
  const { language } = useLanguage();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  // Don't show if not authenticated, already verified, or dismissed
  if (!isAuthenticated || user?.email_verified || dismissed) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${API_URL}/api/auth/resend-verification`, {
        email: user.email
      });
      setSent(true);
    } catch (err) {
      console.error('Failed to resend verification:', err);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="shrink-0">
              <Mail className="w-5 h-5 text-amber-600 dark:text-amber-400" />
            </div>
            <p className="text-sm text-amber-800 dark:text-amber-200">
              {language === 'nl'
                ? 'Je e-mailadres is nog niet geverifieerd. Controleer je inbox voor de verificatie link.'
                : 'Your email is not verified yet. Check your inbox for the verification link.'}
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            {sent ? (
              <span className="flex items-center gap-1 text-sm text-success">
                <CheckCircle className="w-4 h-4" />
                {language === 'nl' ? 'Verzonden!' : 'Sent!'}
              </span>
            ) : (
              <button
                onClick={handleResend}
                disabled={sending}
                className="text-sm font-medium text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100 disabled:opacity-50"
                data-testid="resend-verification-btn"
              >
                {sending ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  language === 'nl' ? 'Opnieuw versturen' : 'Resend'
                )}
              </button>
            )}
            <button
              onClick={() => setDismissed(true)}
              className="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200"
              aria-label="Dismiss"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
